import React from 'react';
import { Bot, Mail, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="border-t border-gray-800/50 bg-black/90 backdrop-blur-md" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-6 sm:mb-8">
          {/* Company Info */}
          <div className="sm:col-span-2 md:col-span-2">
            <div className="flex items-center space-x-2 sm:space-x-3 mb-4 sm:mb-6" role="img" aria-label="DM.AI 4u Company Logo">
              <div className="bg-gradient-to-r from-purple-600 via-blue-500 to-emerald-400 p-2 rounded-xl">
                <Bot className="w-5 h-5 sm:w-6 sm:h-6 text-white" aria-hidden="true" />
              </div>
              <span className="text-xl sm:text-2xl font-display text-white tracking-tight">
                <span className="font-robotic">DM.AI</span> <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-400 via-emerald-400 to-purple-400 font-robotic">4u</span>
              </span>
            </div>
            <p className="text-sm sm:text-base text-gray-400 leading-relaxed mb-4 sm:mb-6 max-w-md font-tech">
              Websites, AI and automation for small businesses. Based in West Yorkshire.
            </p>
            <div className="flex space-x-3 sm:space-x-4" role="list" aria-label="Contact links">
              <a href="mailto:dom@dm4u.ai" className="w-8 h-8 sm:w-10 sm:h-10 bg-gray-800/50 rounded-lg flex items-center justify-center hover:bg-red-500/20 hover:border-red-500/30 border border-gray-700/50 transition-all duration-300 btn-mobile">
                <Mail className="w-4 h-4 sm:w-5 sm:h-5 text-gray-400 hover:text-gray-300" aria-label="Email" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <nav>
            <h4 className="text-white font-bold mb-3 sm:mb-4 font-robotic text-sm sm:text-base">Quick Links</h4>
            <ul className="space-y-1 sm:space-y-2" role="list">
              <li>
                <a
                  href="#our-work"
                  className="text-gray-400 hover:text-blue-400 transition-colors duration-300 text-xs sm:text-sm font-tech btn-mobile"
                >
                  About Us
                </a>
              </li>
              <li><a href="#solutions" className="text-gray-400 hover:text-emerald-400 transition-colors duration-300 text-xs sm:text-sm font-tech btn-mobile">Our Services</a></li>
            </ul>
          </nav>

          {/* Contact */}
          <div>
            <h4 className="text-white font-bold mb-3 sm:mb-4 font-robotic text-sm sm:text-base">Contact</h4>
            <address className="space-y-1 sm:space-y-2 not-italic">
              <div className="flex items-center text-gray-400 text-xs sm:text-sm font-tech">
                <Mail className="w-3 h-3 sm:w-4 sm:h-4 mr-2 flex-shrink-0" aria-hidden="true" />
                <a href="mailto:dom@dm4u.ai" className="hover:text-blue-400 transition-colors duration-300">
                  dom@dm4u.ai
                </a>
              </div>
              <div className="flex items-center text-gray-400 text-xs sm:text-sm font-tech">
                <Phone className="w-3 h-3 sm:w-4 sm:h-4 mr-2 flex-shrink-0" aria-hidden="true" />
                <a href="tel:+447508300353" className="hover:text-blue-400 transition-colors duration-300">
                  07508 300353
                </a>
              </div>
            </address>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800/50 pt-6 sm:pt-8 flex flex-col md:flex-row justify-between items-center space-y-3 sm:space-y-4 md:space-y-0">
          <p className="text-xs sm:text-sm text-gray-400 font-light font-robotic text-center md:text-left">
            <span className="text-blue-400">&copy;</span> DM.AI 4u 2026. All rights reserved.
          </p>
          <div className="flex flex-wrap justify-center gap-4 sm:gap-6">
            <a
              href="/privacy"
              className="text-xs sm:text-sm text-gray-400 hover:text-emerald-400 transition-colors duration-300 font-light font-robotic btn-mobile"
            >
              Privacy Policy
            </a>
            <a
              href="/terms"
              className="text-xs sm:text-sm text-gray-400 hover:text-gray-300 transition-colors duration-300 font-light font-robotic btn-mobile"
            >
              Terms of Service
            </a>
            <a
              href="mailto:dom@dm4u.ai"
              className="text-xs sm:text-sm text-gray-400 hover:text-red-400 transition-colors duration-300 font-light font-robotic btn-mobile"
            >
              Contact Us
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
